  <template>
  <div id="merchandises" style="background-color: white" v-if="merchandises" >
    <nav class="bar bar-nav">
      <a class="button button-link button-nav pull-left"  @click="gotolast()" v-if="!isWapp">
        <span class="icon icon-left"></span>返回
      </a>
    </nav>
    <div  class="content"   style="margin-bottom: 2rem;background-color: white;overflow-y: auto;overflow-x: hidden">
    <div class="page-detail" v-if="merchandises" >
          <div class="item-subtitle" style="color: #0894ec"  >
            <div class="item-title-row"  v-if="merchandises.showpromotion && merchandises.showpromotion.length > 0" >
              <span style="color: slateblue;font-size: 0.6rem;margin-left: 0.2rem">参与促销：
              <span v-for="(proo,index) in merchandises.showpromotion">
                <span v-if="proo.type === 1">
                 {{index+1}}: {{proo.description}}
                </span>
              </span>
              </span>
            </div>
          </div>
          <div class="content-block goods-card" style="font-size: 0.6rem;margin-bottom:1.5rem" >
            <span style="margin-left: 0.3rem" v-for="title in merchandises._titleList"><span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span><span v-else>{{title.valueText}}</span></span>
            <span style="float: right">
               <strong style="color: #4479B4;font-size: 0.9rem" v-if="sessionInfo.customerInfo && sessionInfo.customerInfo.ssoFlag === 1 ">¥{{merchandises.priceMax}}</strong>
           <strong style="color: #4479B4;font-size: 0.9rem" v-else>¥{{merchandises.priceMin}}</strong>
             <del v-if="merchandises.cataloguePrice" style="font-size: 0.5rem">¥{{merchandises.cataloguePrice}}</del>
            </span>
          </div>
          <div class="content-block" >
            <div class="buttons-row">
              <a href="#tab-introduce" class="tab-link  button">产品介绍</a>
              <a href="#tab-detail" class="tab-link active button">详情</a>
              <a href="#tab-qualityCommitment" class="tab-link button">质量承诺</a>
              <a href="#tab-comments" class="tab-link button">评论({{Comments.length}})</a>
            </div>
            <div class="tabs">
              <div class="tab " id="tab-introduce">
                <div v-html="introduces"></div>
                <div v-if="merchandises.manualFileName">
                  <p v-if="introduces === ''">{{merchandises.description}}</p>
                 <p v-if="merchandises.manualFileName !=''">
                  <p v-if="merchandises.manualFileName.split(';').length === 1">
                  <a target="_blank" :href="manualurl + merchandises.manualFileName + attr" >查看商品手册</a>
                  </p>
                  <p  v-if="merchandises.manualFileName.split(';').length !== 1" v-for="(manualFileName,index) in merchandises.manualFileName.split(';')">
                   <a target="_blank" :href="manualurl + manualFileName + attr " >查看商品手册{{index+1}}</a>
                  </p>
                  </p>
                </div>
              </div>
              <div class="tab " id="tab-qualityCommitment">
                <div v-html="qualityCommitment"></div>
              </div>
              <div  class="tab active list-block" id="tab-detail" style="margin-top: 0rem;" >
                <div v-for="merchandise in merchandises._attributesList" style="margin-bottom: 0.3rem;margin-top: 1.2rem;margin-left: 0.2rem;margin-right: 0.2rem" >
                  <div v-if="merchandise.valueText">
                    <div v-if="merchandise.columnName === 'STRSite' && merchandise.valueText.indexOf('；') !== -1">
                      <span style="color: #00469A">{{merchandise.label}}</span>
                      <span style="float: right;padding-top: 0px">
                        <span v-for="value in merchandise.valueText.split('；')">
                         {{ value}}
                          </br>
                        </span>
                      </span>
                      <div style="margin-top: 11rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                    </div>
                    <div v-else-if="merchandise.columnName === 'AdditionalParameters' && merchandise.valueText.indexOf('；') !== -1">
                      <span style="color: #00469A">{{merchandise.label}}</span>
                      <span style="float: right;padding-top: 0px">
                        <span v-for="value in merchandise.valueText.split('；')">
                         {{ value}}
                          </br>
                        </span>
                      </span>
                      <div style="margin-top: 5rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                    </div>
                    <div v-else>
                      <div v-if="merchandise.displayable && merchandise.valueText.length>60">
                        <span style="color: #00469A">{{merchandise.label}}</span>
                        <span style="float: right;width: 9rem;" v-if="merchandise.label === '基因别名' && merchandise.valueText.length > 60 && merchandise.valueText.length < 80 ">
                          <span>
                            {{merchandise.valueText.substring(0,19)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(19,40)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(40,60)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(60)}}
                          </span>
                        </span>
                        <span style="float: right;width: 9rem;" v-else-if="merchandise.label === '基因别名' && merchandise.valueText.length >= 80 && merchandise.valueText.length <100">
                          <span>
                            {{merchandise.valueText.substring(0,19)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(19,40)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(40,60)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(60,80)}}
                          </span>
                          <span>
                            {{merchandise.valueText.substring(80)}}
                          </span>
                        </span>
                        <span style="float: right;width: 9rem;" v-else-if="merchandise.label === '基因别名' && merchandise.valueText.length >= 100">
                          <span>
                            {{merchandise.valueText.substring(0,19)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(19,40)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(40,60)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(60,80)}}
                          </span>
                          <span>
                            {{merchandise.valueText.substring(80, 100)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(100)}}
                          </span>
                        </span>

                        <span style="float: right;width: 9rem;" v-else>
                          <span>
                            {{merchandise.valueText}}
                          </span>
                        </span>
                        <div style="margin-top: 7rem" v-if="merchandise.label === '基因别名'"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;" ></div>
                        <div style="margin-top: 11rem" v-else><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;" ></div>
                      </div>
                      <div v-if="merchandise.displayable && merchandise.valueText.length>45 && merchandise.valueText.length<=60">
                        <span style="color: #00469A">{{merchandise.label}}</span>
                        <span style="float: right;width: 9rem;" v-if="merchandise.label === '基因别名'">
                          <span>
                            {{merchandise.valueText.substring(0,19)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(19, 39)}}
                          </span>
                          <span>
                            {{merchandise.valueText.substring(39,58)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(58)}}
                          </span>
                        </span>
                        <span style="float: right;width: 9rem;" v-else>{{merchandise.valueText}}</span>

                        <div style="margin-top: 5rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                      </div>
                      <div v-if="merchandise.displayable && merchandise.valueText.length>30 && merchandise.valueText.length<=45">
                        <span style="color: #00469A">{{merchandise.label}}</span>
                        <span style="float: right;width: 9rem;" v-if="merchandise.label === '基因别名' && merchandise.valueText.length<=38 ">
                          <span>
                            {{merchandise.valueText.substring(0,19)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(19)}}
                          </span>
                        </span>
                        <span style="float: right;width: 9rem;" v-else-if="merchandise.label === '基因别名' && merchandise.valueText.length > 38 ">
                          <span>
                            {{merchandise.valueText.substring(0,19)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(19, 38)}}
                          </span>
                           <span>
                            {{merchandise.valueText.substring(38)}}
                          </span>
                        </span>
                        <span style="float: right;width: 8rem;" v-else>{{merchandise.valueText}}</span>

                        <div style="margin-top: 3.8rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                      </div>
                      <div v-if="merchandise.displayable && merchandise.valueText.length>16 && merchandise.valueText.length<=30">
                        <span style="color: #00469A">{{merchandise.label}}</span>
                        <span style="float: right;width: 9rem;" v-if="merchandise.label === '基因别名'">
                          <span>
                            {{merchandise.valueText.substring(0,19)}}
                          </span>
                            <span>
                            {{merchandise.valueText.substring(19)}}
                          </span>
                        </span>
                        <span style="float: right;width: 10rem;" v-else>{{merchandise.valueText}}</span>

                        <div style="margin-top: 3rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                      </div>
                      <div v-if="merchandise.displayable && merchandise.valueText.length<=16 ">
                        <span style="color: #00469A">{{merchandise.label}}</span>
                        <span style="float: right;">{{merchandise.valueText}}</span>

                        <div style="margin-top: 1.5rem"><hr style=" height:0.06rem;
    border:0.06rem;
    background-color:#B4B4B4;"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="merchandises._cycle">
                  <span style="color: #00469A">{{merchandises._cycle.label}}</span>
                 <span style="float: right;">{{merchandises._cycle.valueText}}</span>

                </div>
              </div>
              <div class="tab" id="tab-comments" style="margin-left: 0rem">
                <div class="list-block media-list" >
                  <ul  v-if="Comments.length > 0" >
                    <li v-for="comment in Comments">
                      <div class="item-content" >
                        <div class="item-media"><img src="/emktResources/resocurces/img/user.jpg" width="50"></div>
                        <div class="item-inner">
                          <div class="item-title-row">
                            <div class="item-title">{{comment.customerName}}</div>
                            <div class="item-after">{{comment.createDT.split(' ')[0]}}</div>
                          </div>
                          <div ><span  style="background-color: yellow;margin-left: 0.2rem" v-for="index in comment.commentLevel " class="icon icon-star star"></span></div>
                          <div class="item-text">{{comment.comments}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div v-else>
                    暂无用户评价！
                  </div>
                </div>
               </div>
            </div>
          </div>
        </div>
    </div>
    <footer class="bar  bar-tab" :style="{'height': emkt.leaveSpaceForFullScreen ? '85px' : '2.5rem'}">
      <div class="item-media"   >
        <div class="tab-item" style="float: left;margin-left: 2rem" v-if="hasLogin">
          <span class="icon icon-message" @click="toMessage(merchandises.merchandiseLabel)" ></span>
          <span @click="toMessage(merchandises.merchandiseLabel)" class="tab-label" style="width: 1.5rem">客服</span>
          <span class="badge"  v-if="curMessageSession.leaveMessageStatus === 3">1</span>
        </div>
        <div class="tab-item" style="width: 10rem" @click="gotoCart">
          <span class="icon icon-cart" ></span>
          <span class="tab-label">购物车</span>
          <span class="badge" v-if = "getTotalGoodsNum > 0">{{getTotalGoodsNum}}</span>
        </div>
        <section class="gotopay" v-if="QuoteStatus === false">
          <span class="gotopay_button_style" style="padding-top: 0rem" v-on:click="addCartList(merchandises)">加入购物车</span>
        </section>
        <section class="gotopay" v-else  style="background-color: gray">
          <span class="gotopay_button_style" style="padding-top: 0rem;">加入购物车</span>
        </section>
      </div>
    </footer>
  </div>
  <div v-else style="margin-top: 11rem;text-align: center;font-size: 200%">
    <div>
     此商品已经下架！
    </div>

  </div>
</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import Emkt from '../../emkt'
  // import $ from 'jquery'
  import wx from 'wx'
//  import emkt from '../../emkt.js'

  export default {
    mounted () {
      // console.log('mounted')
//      this.fetchData()
    },
    created () {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
      this.fetchData()
    },
    data () {
      return {
        merchandises: [],
        baseurl: '/emktResources/resocurces/img/merchandise/',
        manualurl: '/emktResources/resocurces/manual/',
        merchandiseurl: '/emktResources/resocurces/merchandiseInfo',
        attr: '?go=true',
        Comments: [],
        QuoteStatus: Emkt.getLocalStorage('QuoteStatus'),
        qualityCommitment: '',
        introduces: ''
//        goodList: []
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      // '$route': 'fetchData'
    },
    computed: {
      ...mapState([
        'cartList', 'leaveMessageStatus', 'sessionInfo', 'curMessageSession'
      ]),
      ...mapGetters([
        'hasLogin', 'curMessageSession', 'isWapp'
        // ...
      ]),
//      title () {
//        if (this.merchandiseAttributes === []) {
//          return ''
//        } else {
//          return this.merchandiseAttributes[0].valueText
//        }
//      },
//      merchandiseAttributes () {
//        if (this.merchandise._attributesList === []) {
//          return []
//        } else {
//          return this.merchandise._attributesList
//        }
//      },
      getTotalGoodsNum () {
        var self = this
        let number = 0
        for (let key in self.cartList.cartContent) {
          if (self.cartList.cartContent[key].productQuantity) {
            number = number + self.cartList.cartContent[key].productQuantity
          } else {
            number = number + 1
          }
        }
        return number
      }
//      merchandiseList: function () {
//        this.gcapi('getMerchandiseDetails', this.$route.query.id).then((response) => {
//          this.merchandises = response.body.result
//          this.merchandises.tags = this.$route.query.tags
//          this.merchandises.attrs = this.$route.query.attrs
//          this.merchandises.attributesList = response.body.result._attributesList
//        })
//        return this.merchandises
//      }
    },
    methods: {
      ...mapMutations([
        'ADD_CART_LIST', 'SHOW_GOODS', 'SEND_MESSAGE'
      ]),
      addCartList () {
        if (this.merchandises.selfOperated === 0 && this.sessionInfo.customerInfo.ssoFlag === 1) {
          this.$weui.topTips('第三方商品不支持此操作！')
          // $.toast('第三方商品不支持此操作！')
          return
        }
//        if (this.merchandises.stockOrCustomized === 0 && emkt.buyCartIsLocalStorage === false) {
//          alert('只能对定制产品进行报价！')
//        } else {
//          let pl = this.plan
//          let pr = this.merchandises
//          console.log(pl, pr)
//          this.ADD_CART_LIST(pr)
//        }
        let pl = this.plan
        let pr = this.merchandises
        if (this.merchandises.salesLimit !== -1) {
          if (this.merchandises.totalSales >= this.merchandises.salesLimit) {
            this.$weui.alert('此商品已经售罄！')
            // $.confirm('此商品已经售罄！')
          } else {
            console.log(pl, pr)
            this.ADD_CART_LIST(pr)
          }
        } else {
          this.ADD_CART_LIST(pr)
        }
      },
      tolast () {
        this.$router.go(-1)
      },
      gotoCart () {
        if (Emkt.isWapp) {
          wx.miniProgram.switchTab({
            url: '/pages/cart/cart'
          })
        } else {
          this.$router.replace({name: 'cart'})
        }
      },
      fetchData () {
        this.gcapi('getMerchandiseDetails', this.$route.query.id).then((response) => {
          this.merchandises = response.body.result
          var showpromotion = []
          for (var i in this.merchandises.promotions) {
            if (this.merchandises.promotions[i].type === 1) {
              const samePromotionName = showpromotion.find((item) => item.name === this.merchandises.promotions[i].name)
              if (!samePromotionName) {
                showpromotion.push(this.merchandises.promotions[i])
              }
            }
          }
          this.merchandises.showpromotion = showpromotion
          if (this.merchandises.H5FileName) {
            this.$http.get(this.merchandiseurl + '/static/desc/' + this.merchandises.H5FileName, {emulateHTTP: true}).then((response) => {
              this.introduces = response.bodyText
            })
          }
          if (this.merchandises.QualityPromisesH5FileName) {
            var dictionariesMap = Emkt.getLocalStorage('EmktMetaData').dictionariesMap
            let name = dictionariesMap['61090_' + this.merchandises.QualityPromisesH5FileName].dictValue
            this.$http.get(this.merchandiseurl + '/static/desc/qualitypromises/' + name, {emulateHTTP: true}).then((response) => {
              this.qualityCommitment = response.bodyText
            })
          }
          console.log(this.merchandises)
        })
        this.gcapi('getMerchandiseComments', this.$route.query.id).then((response) => {
          this.Comments = response.body.result
        })
      },
      toMessage (merchandiseLabel) {
        if (Emkt.isWapp) {
          wx.miniProgram.navigateTo({
            url: '/pages/consult/consult'
          })
        } else {
          Emkt.openCustomerService()
        }
        // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
//        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
      },
      gotolast () {
        this.$router.go(-1)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .gotopay{
    position: absolute;
    right: 0;
    background-color: #00469A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -2.5rem;
    width: 5rem;
    height: 3rem;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
    color: #fff;

  }
   .list-block, .content-block {
     margin: 0.75rem 0;
   }
</style>



// WEBPACK FOOTER //
// Merchandises.vue?7dc39a71